import { AppIcon } from '@/components/ui/app-icon';
import { RotatingQuote } from '@/containers/onboarding/rotating-quote.component';
import { iconStarSolid } from '@/lib/icons';
import { BRAND, siteUrl } from '@/lib/brand';

/** What sits under the onboarding card on the form and the trial page. */

const legalLink =
  'font-medium text-foreground underline decoration-black/25 underline-offset-2 hover:decoration-black/60 dark:decoration-white/25 dark:hover:decoration-white/60';

/** Under the form: the org-level agreement. */
export function LegalLine() {
  return (
    <>
      By clicking Continue, you agree to {BRAND.name}&apos;s{' '}
      <a
        href={siteUrl('https://www.cleanlist.ai/terms-conditions')}
        target='_blank'
        rel='noopener noreferrer'
        className={legalLink}
      >
        Terms
      </a>{' '}
      and{' '}
      <a
        href={siteUrl('https://www.cleanlist.ai/privacy-policy')}
        target='_blank'
        rel='noopener noreferrer'
        className={legalLink}
      >
        Privacy Policy
      </a>{' '}
      on behalf of your organization.
    </>
  );
}

const REVIEW_SOURCES = [
  { src: '/logos/g2.png', name: 'G2' },
  { src: '/logos/chrome-web-store-mark.png', name: 'Chrome Web Store' },
  { src: '/logos/appsumo-mark.png', name: 'AppSumo' },
];

/** The rating, with where the reviews come from. */
export function ReviewsLine() {
  return (
    <span className='inline-flex items-center gap-2'>
      <span className='flex items-center gap-1'>
        {REVIEW_SOURCES.map((source) => (
          <img
            key={source.name}
            src={source.src}
            alt={source.name}
            title={source.name}
            className='h-4 w-4 object-contain'
          />
        ))}
      </span>
      <span className='flex gap-0.5 text-[#ffb020]' aria-hidden='true'>
        {Array.from({ length: 5 }, (_, i) => (
          <AppIcon key={i} icon={iconStarSolid} className='h-2.5 w-2.5' />
        ))}
      </span>
      4.8 from 150+ reviews
    </span>
  );
}

/** Under the trial card: a customer in their words, rotating, then the
 *  rating. */
export function TrialFooter() {
  return (
    <div className='flex flex-col items-center gap-4'>
      <RotatingQuote />
      <ReviewsLine />
    </div>
  );
}
